import { InMemoryReactiveState as c } from "./index2.js";
import { LocalStorageState as i } from "./index3.js";
import { StateFacade as n } from "./index4.js";
const r = {};
function s(e, o) {
  let t = r[e];
  if (t === void 0) {
    const a = new c(
      o
    ), S = new i(
      e,
      o
    );
    t = new n(S, a), r[e] = t;
  }
  return t;
}
export {
  s as getSharedState
};
//# sourceMappingURL=index.js.map
